import { IdType } from '../store/entities/types';

const useCustomOrgShowTime = (orgId: IdType) => ({ customShowTime: orgId !== 602 });

export default useCustomOrgShowTime;
